<template>
  <div class="carQuery full-height carQuery-banner">
    <ld-header v-show="cardShow" transparent white @click-left="back">
      <img slot="left" class="custom-back" style="z-index: 999;" :src="backIcon">
      <trip-type slot="right" v-if="$store.state.app.business" />
    </ld-header>

    <ld-navbar v-show="confirmPullupPopup" style="position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        width: 100%;" @click-left="confirmScddBack">
      <van-search v-model.lazy="realTimeCar.fromAddressName" :placeholder="realTimeCar.placeholder" disabled
                  maxlength="10" @click="showingSite(1)">
        <div slot="label" class="main-color van-ellipsis" style="max-width:60px" @click.stop="toggle('confirmCity')">
          <span>{{ realTimeCar.confirmCityName || '选择城市' }}</span>
        </div>
      </van-search>
    </ld-navbar>

    <!-- 地图 -->
    <transition name="van-fade">
      <div v-show="useType == 5" id="carQueryMap" style="position: absolute;
              width: 100vw;
              height: calc(100vh + 266px);
              top: -266px;
              z-index: 0;" />
    </transition>

    <!--  -->
    <div :style="isXlminiprogram ? 'bottom:60px;' : ''" class="plus-card-wrap">
      <div v-show="cardShow" class="card">
        <!-- 出差申请单 -->
        <van-row v-if="serviceCtrl.isShowCcsqd">
          <van-col class="ccsqd-col" span="24">
            <van-cell :border="false" is-link @click.stop="$refs.ccsqdlist.toggle()">
              <template slot="title">
                <div :class="[carSearchInfo.Ccsqd.ccsqdNo ? '' : 'gray']">
                  {{ carSearchInfo.Ccsqd.ccsqdNo || $t('K108', '请选择出差单') }}
                </div>
              </template>
            </van-cell>
          </van-col>
        </van-row>

        <!--  -->
        <van-tabs v-model="name" :border="false" line-height="3" line-width="16" @click="changeTabs(name)">
          <!-- 接送机 -->
          <van-tab v-if="carProType[0] == 1" :title="$t('J012', '接送机')" name="0">
            <van-row align="center" class="pad" gutter="16" type="flex">
              <van-col span="12">
                <ld-button v-show="useType == 0" class="btn fr" main3 size="md" @click.native="changeTab(0)">
                  {{ $t('J002', '接机') }}
                </ld-button>
                <span v-show="useType == 1" class="fr btn text-center" @click="changeTab(0)">{{ $t('J002', '接机') }}</span>
              </van-col>
              <van-col>
                <ld-button v-show="useType == 1" class="btn fl" main3 size="md" @click.native="changeTab(1)">
                  {{ $t('J003', '送机') }}
                </ld-button>
                <span v-show="useType == 0" class="fl btn text-center" @click="changeTab(1)">{{ $t('J003', '送机') }}</span>
              </van-col>
            </van-row>
            <!-- 接机 -->
            <div v-show="useType == 0">
              <van-row align="center" type="flex">
                <van-col :span="2">
                  <img :src="airportPickup.img" alt="." class="full-width vertical-bottom">
                </van-col>
                <van-col :span="22" class="van-hairline--bottom">
                  <van-row align="center" type="flex">
                    <van-col :span="airportPickup.flightDisabled ? 24 : 18" class="airport-pickup-col">
                      <van-field v-show="!airportPickup.flightNo" v-model="airportPickup.flightNo" :border="false"
                                 :placeholder="airportPickup.holder" readonly @click="chooseCity()" />
                      <van-cell v-show="airportPickup.voyage" :class="{ 'flight-disabled': airportPickup.flightDisabled }"
                                :label="airportPickup.desc" :title="airportPickup.voyage"
                                @click="!airportPickup.flightDisabled && chooseCity()" />
                    </van-col>
                    <van-col v-show="!airportPickup.flightDisabled" :span="6">
                      <span class="dBtn main-color" @click="myFlight(1)">
                        {{ $t('J052', '我的航班') }}
                      </span>
                    </van-col>
                  </van-row>
                </van-col>
              </van-row>
              <van-row align="center" type="flex">
                <van-col span="2">
                  <img alt="." class="full-width vertical-bottom" :src="xcPlaceIcon">
                </van-col>
                <van-col class="van-hairline--bottom" span="22">
                  <van-field v-model="airportPickup.xcdd" :placeholder="airportPickup.placeholder" :readonly="true"
                             @click="showingSite" />
                </van-col>
              </van-row>
            </div>

            <!-- 送机 -->
            <div v-show="useType == 1">
              <van-row align="center" type="flex">
                <van-col :span="2">
                  <img :src="airportDropOff.img" alt="." class="full-width vertical-bottom">
                </van-col>
                <van-col :span="22" class="van-hairline--bottom">
                  <van-row align="center" type="flex">
                    <van-col :span="airportDropOff.flightDisabled ? 24 : 18" class="airport-pickup-col">
                      <van-field v-show="!airportDropOff.flightNo && !airportDropOff.departAirportName"
                                 v-model="airportDropOff.departAirportName" :border="false" :placeholder="airportDropOff.holder"
                                 readonly @click="chooseCity()" />
                      <van-cell v-if="airportDropOff.desc == '  undefined  出发' || descShow == true"
                                v-show="airportDropOff.voyage" :class="{ 'flight-disabled': airportDropOff.flightDisabled }"
                                @click="!airportDropOff.flightDisabled && chooseCity()">
                        {{ airportDropOff.voyage }}
                      </van-cell>

                      <van-cell v-else v-show="airportDropOff.voyage"
                                :class="{ 'flight-disabled': airportDropOff.flightDisabled }" :label="airportDropOff.desc"
                                :title="airportDropOff.voyage" @click="!airportDropOff.flightDisabled && chooseCity()" />
                    </van-col>
                    <van-col v-show="!airportDropOff.flightDisabled" :span="6">
                      <span class="dBtn main-color" @click="myFlight(2)">
                        {{ $t('J052', '我的航班') }}
                      </span>
                    </van-col>
                  </van-row>
                </van-col>
              </van-row>
              <van-row v-show="terminal.length" align="center" type="flex">
                <van-col span="2">
                  <img alt="." class="full-width vertical-bottom" :src="xcPlaceIcon">
                </van-col>
                <van-col class="van-hairline--bottom" span="22">
                  <van-field v-model="airportDropOff.departTerminalName" :placeholder="$t('Q002', '航站楼')" :readonly="true"
                             @click="showTerminal = !showTerminal" />
                </van-col>
              </van-row>
              <van-row align="center" type="flex">
                <van-col span="2">
                  <img alt="." class="full-width vertical-bottom" :src="xcPlaceIcon">
                </van-col>
                <van-col class="van-hairline--bottom" span="16">
                  <van-field v-model="airportDropOff.scdd" :placeholder="airportDropOff.placeholder" :readonly="true"
                             @click="showingSite" />
                </van-col>
                <van-col class="text-center" span="6">
                  <span class="dBtn main-color" @click="appGps">
                    我的位置
                  </span>
                </van-col>
              </van-row>
              <!--  -->
              <van-row align="center" type="flex">
                <van-col span="2">
                  <img alt="" class="full-width vertical-bottom" :src="timeIcon">
                </van-col>
                <van-col span="22">
                  <van-field v-if="airportDropOff.desc.includes('undefined')" v-model="airportDropOff.useTimeName"
                             :placeholder="$t('J236', '选择用车时间') + ',具体以电话通知为准'" :readonly="true" @click="$refs.picker.toggle()" />
                  <van-field v-else v-model="airportDropOffTime" :placeholder="$t('J236', '选择用车时间') + ',具体以电话通知为准'"
                             :readonly="true" @click="$refs.picker.toggle()" />
                </van-col>
              </van-row>
            </div>
          </van-tab>

          <!--接送站  -->
          <van-tab v-if="carProType[1] == 1" :title="$t('J013', '接送站')" name="1">
            <van-row align="center" class="pad" gutter="16" type="flex">
              <van-col span="12">
                <ld-button v-show="useType == 2" class="btn fr" main3 size="md" @click.native="changeTab(2)">
                  {{ $t('J005', '接站') }}
                </ld-button>
                <span v-show="useType == 3" class="fr btn text-center" @click="changeTab(2)">
                  {{ $t('J005', '接站') }}
                </span>
              </van-col>
              <van-col>
                <ld-button v-show="useType == 3" class="btn fl" main3 size="md" @click.native="changeTab(3)">
                  {{ $t('J006', '送站') }}
                </ld-button>
                <span v-show="useType == 2" class="fl btn text-center" @click="changeTab(3)">
                  {{ $t('J006', '送站') }}
                </span>
              </van-col>
            </van-row>

            <!-- 接站 -->
            <div v-show="useType == 2">
              <van-row align="center" type="flex">
                <van-col :span="2">
                  <img :src="receivingStation.img" alt="." class="full-width vertical-bottom">
                </van-col>
                <van-col :span="22" class="van-hairline--bottom">
                  <van-field v-model="receivingStation.scdd" :border="false" :placeholder="receivingStation.holder"
                             :readonly="true" @click="chooseCity()" />
                </van-col>
              </van-row>
              <!--  -->
              <van-row align="center" type="flex">
                <van-col span="2">
                  <img alt="." class="full-width vertical-bottom" :src="xcPlaceIcon">
                </van-col>
                <van-col class="van-hairline--bottom" span="22">
                  <van-field v-model="receivingStation.xcdd" :placeholder="receivingStation.placeholder" :readonly="true"
                             @click="showingSite" />
                </van-col>
              </van-row>
            </div>

            <!--送站 -->
            <div v-show="useType == 3">
              <van-row align="center" type="flex">
                <van-col :span="2">
                  <img :src="sendingStation.img" alt="." class="full-width vertical-bottom">
                </van-col>
                <van-col :span="22" class="van-hairline--bottom">
                  <van-field v-model="sendingStation.xcdd" :border="false" :placeholder="sendingStation.holder"
                             :readonly="true" @click="chooseCity()" />
                </van-col>
              </van-row>
              <van-row align="center" type="flex">
                <van-col span="2">
                  <img alt="." class="full-width vertical-bottom" :src="xcPlaceIcon">
                </van-col>
                <van-col class="van-hairline--bottom" span="16">
                  <van-field v-model="sendingStation.scdd" :placeholder="sendingStation.placeholder" :readonly="true"
                             @click="showingSite" />
                </van-col>
                <van-col class="text-center" span="6">
                  <span class="dBtn main-color" @click="appGps">
                    我的位置
                  </span>
                </van-col>
              </van-row>
            </div>
            <!--  -->
            <van-row align="center" type="flex">
              <van-col span="2">
                <img alt="" class="full-width vertical-bottom" :src="timeIcon">
              </van-col>
              <van-col span="22">
                <van-field v-if="useType == 2" v-model="receivingStation.useTimeName"
                           :placeholder="$t('J236', '选择用车时间') + ',具体以电话通知为准'" :readonly="true" @click="$refs.picker.toggle()" />
                <van-field v-if="useType == 3" v-model="sendingStation.useTimeName"
                           :placeholder="$t('J236', '选择用车时间') + ',具体以电话通知为准'" :readonly="true" @click="$refs.picker.toggle()" />
              </van-col>
            </van-row>
            <!--  -->
          </van-tab>

          <van-tab v-if="carProType[2] == 1" :title="$t('J237', '即时用车')" name="3">
            <van-row align="center" class="pad" gutter="16" type="flex">
              <van-col span="12">
                <ld-button v-show="jsycType == 8" class="btn fr" main3 size="md">
                  即时
                </ld-button>
                <span v-show="jsycType == 9" class="fr btn text-center" @click="jsycType = 8">
                  即时
                </span>
              </van-col>
              <van-col>
                <ld-button v-show="jsycType == 9" class="btn fl" main3 size="md">
                  预约
                </ld-button>
                <span v-show="jsycType == 8" class="fl btn text-center" @click="jsycType = 9">
                  预约
                </span>
              </van-col>
            </van-row>

            <van-row v-if="jsycingOrder" align="center" class="pad" type="flex">
              <van-col span="18">
                有
                <van-tag round type="danger">
                  1
                </van-tag>
                个订单正在进行中
              </van-col>
              <van-col span="4">
                <span class="dBtn main-color" @click="searchJsyc(jsycingOrder.orderId)">
                  {{ $t('B011', '查看订单') }}
                </span>
              </van-col>
            </van-row>

            <template v-if="!jsycingOrder">
              <!-- <template> -->
              <van-row v-if="jsycType == 9" align="center" type="flex">
                <van-col span="2">
                  <img alt="" class="full-width vertical-bottom" :src="timeIcon">
                </van-col>
                <van-col span="22">
                  <van-field v-model="realTimeCar.useTimeName" :placeholder="$t('J236', '选择用车时间') + ',具体以电话通知为准'" readonly
                             @click="$refs.picker.toggle()" />
                </van-col>
              </van-row>

              <van-row align="center" type="flex">
                <van-col span="2">
                  <img alt="." class="full-width vertical-bottom" :src="xcPlaceIcon">
                </van-col>
                <van-col class="van-hairline--bottom" span="22">
                  <van-field v-model="realTimeCar.fromAddressName" :placeholder="realTimeCar.placeholder" readonly
                             @click="showingSite(1)" />
                </van-col>
              </van-row>
              <van-row align="center" type="flex">
                <van-col span="2">
                  <img alt="." class="full-width vertical-bottom" :src="scPlaceIcon">
                </van-col>
                <van-col class="van-hairline--bottom" span="22">
                  <van-field v-model="realTimeCar.toAddressName" :placeholder="realTimeCar.holder" :readonly="true"
                             @click="showingSite(2)" />
                </van-col>
              </van-row>

              <van-row align="center" class="pad" type="flex">
                <!-- <van-col
                span="10"
                offset="2"
              >
                <span
                  style="width: 100%;height: 44px;line-height: 44px;"
                  class="dBtn main-color"
                  @click="didiSSO"
                >
                  滴滴出行
                </span>
              </van-col>
              <van-col
                span="10"
                offset="1"
              > -->
                <ldButton main size="lg" @click.native="searchJsyc('')">
                  {{ $t('B002', '查询') }}
                </ldButton>
                <!-- </van-col> -->
              </van-row>
            </template>
          </van-tab>

          <!-- 包车 -->
          <van-tab v-if="carProType[3] == 1" name="2" title="包车">
            <van-cell :border="false" title="需要跨城用车">
              <van-switch v-model="charteredCar.useRange" size="20" />
            </van-cell>
            <van-row align="center" type="flex">
              <van-col :span="2">
                <img :src="charteredCar.img" alt="." class="full-width vertical-bottom">
              </van-col>
              <van-col :span="22" class="van-hairline--bottom">
                <van-field v-model="charteredCar.departCityName" :border="false" :placeholder="charteredCar.holder"
                           :readonly="true" @click="chooseCity()" />
              </van-col>
            </van-row>
            <!--  -->
            <!--上下车地点  -->
            <van-row align="center" type="flex">
              <van-col span="2">
                <img alt="." class="full-width vertical-bottom" :src="xcPlaceIcon">
              </van-col>
              <van-col class="van-hairline--bottom" span="22">
                <van-field v-model="charteredCar.scdd" :placeholder="charteredCar.placeholder" :readonly="true"
                           @click="showingSite" />
              </van-col>
            </van-row>
            <!--  -->
            <van-row align="center" type="flex">
              <van-col span="2">
                <img alt="" class="full-width vertical-bottom" :src="timeIcon">
              </van-col>
              <van-col span="14">
                <van-field v-model="charteredCar.useTimeName" :readonly="true" placeholder="选择用车时间,具体以电话通知为准"
                           @click="$refs.picker.toggle()" />
              </van-col>
              <van-col span="8">
                <van-stepper v-model="charteredCar.useDays" disable-input max="100" min="0.5" step="1"
                             @change="stepperChange" />
              </van-col>
            </van-row>
          </van-tab>
        </van-tabs>
      </div>

      <transition name="van-slide-up">
        <div v-show="confirmPullupPopup" class="van-popup van-popup--round van-popup--bottom query"
             style="z-index: 2003;">
          <van-row>司机将在此处与您见面 :</van-row>
          <van-row class="font24 font-bold" style="margin-top: 8px;">
            {{ params.fromAddressName }}
          </van-row>
          <div style="margin-top: 16px;">
            <ldButton main size="lg" @click.native="searchJsyc('')">
              确认上车点
            </ldButton>
          </div>
        </div>
      </transition>

      <!--  -->
      <div v-if="useType != 5" class="query">
        <ldButton main size="lg" @click.native="search">
          {{ $t('B002', '查询') }}
        </ldButton>
      </div>

      <!-- 城市 -->
      <city v-if="confirmPullupPopup" ref="confirmCity" :is-car="true" :show-tab="false" :sys-type="way"
            @selected="confirmCitySelected" />
      <city v-else ref="city" :is-car="true" :show-tab="false" :sys-type="way" @selected="getCity" />

      <!--航班列表  -->
      <car-flights ref="myFlights" :data="myFlightData" :use-type="myflt" @selected="getFlight" />

      <!-- 查询航班 -->
      <query-flights ref="queryFlights" @getParams="getFlight" @selected="queryFlights" />

      <!-- 位置列表 -->
      <van-popup v-model="showSite" class="full-width full-height" position="right">
        <ht-search v-if="useType == 5" :car-type="carType" :city-id="confirmPullupPopup ? params.confirmCityId : cityId"
                   :city-name="confirmPullupPopup ? params.confirmCityName : cityName" :is-car="true" placeholder="请输入关键字"
                   @callBack="hideSite" @selected="jsycSite" />
        <ht-search v-else :car-type="carType" :city-id="cityId" :city-name="cityName" :is-car="true" placeholder="请输入关键字"
                   @callBack="hideSite" @selected="getSite" />
      </van-popup>

      <!-- 航站楼 -->
      <van-popup v-model="showTerminal" position="bottom">
        <van-picker :columns="terminal" :title="$t('Q002', '航站楼')" show-toolbar @cancel="showTerminal = false"
                    @confirm="selectTerminal" />
      </van-popup>

      <!--用车时间  -->
      <ld-date-picker ref="picker" @confirm="selectDate" />

      <car-driving v-if="useType == 5" ref="carDriving" :data="realTimeCar" @cancel="queryJsycing(); queryWillPay()"
                   @changeFromAddress="changeFromAddress" @changeToAddress="showingSite(2)" />

      <!-- 出差申请单 -->
      <ld-check-list v-if="serviceCtrl.isShowCcsqd" ref="ccsqdlist" :params="ccsqdParams" type="4"
                     @selected="ccsqdSelect" />
    </div>

    <!-- 底部tabbar -->
    <van-tabbar v-if="isXlminiprogram" safe-area-inset-bottom>
      <van-tabbar-item @click="toOrderList">
        <img slot="icon" src="~Assets/images/ht/myOrder.png">
        <span class="deep-gray">用车订单</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import {
  Tabbar,
  TabbarItem,
  Image,
  Popup,
  Cell,
  Field,
  Picker,
  CellGroup,
  Tab,
  Tabs,
  Stepper,
  Switch,
  Tag,
  Search
} from 'vant'

import { mapGetters, mapActions } from 'vuex'
import { formatDate, getDiffHour, getPreStrTime } from 'Utils/dateUtil'
import ldButton from 'Common/ldButton'
import tripType from 'Common/tripType'
import City from 'Common/city'
import ldDatePicker from 'Common/ldDatePicker'
import carFlights from './flight/carFlights'
import queryFlights from './flight/queryCarFlights'
import htSearch from 'Views/Ht/htQuery/htSearch/index.vue'
import { localget, localset, localremove } from 'Utils/storage'
import { objectToQueryString } from 'Utils/object'
import ldCheckList from 'Components/ldCheckList'
import carDriving from './carDriving'
import backIcon from '@/business/assets/images/back.png'
import timeIcon from '@/business/assets/images/car/time.png'
import scPlaceIcon from '@/business/assets/images/car/scPlace.png'
import xcPlaceIcon from '@/business/assets/images/car/xcPlace.png'
import flightNo from 'Assets/images/car/flightNo.png'
import station from 'Assets/images/car/station.png'
import scPlace from 'Assets/images/car/scPlace.png'
import xcPlace from 'Assets/images/car/xcPlace.png'
import AMap from './AMap'
import { openWebview } from '@/common/utils/plus'
// import { changeBlur } from '@/business/utils/tools'
import amap from 'Utils/amap'
import { getSysType } from 'CommonUtils/plus.js'
import { gcj02tobd09 } from 'Utils/convertGps.js'
import { isXlminp, goXlHome } from 'Utils/xltools'
import defaultMixin from '../../../mixins/default'
import { queryVipParameter, getParameter } from 'Utils/publicApi'

/**
 * 订单详情用车类型对应滴滴的跳转页面取值
 */
const USETYPE_JUMPPAGE = {
  3: 'airportPickUp',
  4: 'toAirport',
  6: 'stationPickUp',
  7: 'toStation',
  8: 'callCarNow',
  9: 'callCarAppointment',
}
const TOM_Date = formatDate(new Date(), 1)
const Default_DATE = formatDate(`${TOM_Date.date} 09:00`) // 默认时间 明早9点

const useType = {
  0: 'airportPickup',
  1: 'airportDropOff',
  2: 'receivingStation',
  3: 'sendingStation',
  4: 'charteredCar',
  5: 'realTimeCar',
}

// 防止页面后退，行路除外
if (!isXlminp()) {
  history.pushState(null, null, document.URL)
  window.addEventListener('popstate', forbidBack)
}

function forbidBack() {
  history.pushState(null, null, document.URL)
}


export default {
  name: 'CarQuery',
  mixins: [defaultMixin],
  components: {
    ldButton,
    City,

    tripType,
    carFlights,
    queryFlights,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Image.name]: Image,
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [CellGroup.name]: CellGroup,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Stepper.name]: Stepper,
    [Switch.name]: Switch,
    [Tag.name]: Tag,
    [Search.name]: Search,
    carDriving,
    htSearch,
    ldDatePicker,
    ldCheckList,
    ldNavbar: () => import('Common/ldNavbar'),
  },
  data() {
    return {
      term: [],
      backIcon,
      timeIcon,
      scPlaceIcon,
      xcPlaceIcon,
      name: '0',
      useType: 0, // 0 接机 1 送机 2接站 3送站 4包车 5即时用车
      departDate: formatDate(new Date()).date + ' ' + formatDate(new Date()).hm, //出发时间
      arriveDate: formatDate(new Date(), 1).date, //回程时间
      cardShow: true,
      params: {},
      confirmPullupPopup: false,
      way: 1, //1 出发城市  2到达城市
      //接机
      airportPickup: {
        placeholder: this.$t('J228', '您要去哪儿'),
        // holder: this.$t('MU9855', '请输入航班号'),
        holder: '请点击“我的航班”或输入航班号',
        tips: this.$t('J230', '请选择到达航班'),
        img: flightNo,
        useType: '0',
        scimg: flightNo,
        xcimg: xcPlace,
        arriveCity: '',
        arriveCityName: '',
        flightNo: '',
        cityId: '',
        voyage: '',
        desc: '',
        scdd: '',
        xcdd: '',
        flightDisabled: false,
        sclocation: { lat: '', lng: '' },
        xclocation: { lat: '', lng: '' },
      },
      //送机
      airportDropOff: {
        placeholder: this.$t('J229', '您从哪儿出发'),
        holder: '请点击“我的航班”或输入航班号',
        // holder: this.$t('J228', '您要去哪儿'),
        tips: this.$t('J231', '请选择出发机场'),
        img: flightNo,
        useType: 1,
        xcimg: flightNo,
        scimg: xcPlace,
        cityId: '',
        // useTimeName:`${Default_DATE.monDayWeek} ${Default_DATE.hm}`,
        useTimeName: '',
        // useTime:`${Default_DATE.date} ${Default_DATE.hm}`,
        useTime: '',
        departAirportName: '',
        voyage: '',
        desc: '',
        scdd: '',
        scaddress: '',
        xcdd: '',
        xcaddress: '',
        terminal: '',
        flightDisabled: false,
        sclocation: { lat: '', lng: '' },
        xclocation: { lat: '', lng: '' },
      },
      //接站
      receivingStation: {
        placeholder: this.$t('J228', '您要去哪儿'),
        holder: this.$t('J233', '请选择到达站点'),
        tips: this.$t('J233', '请选择到达站点'),
        img: station,
        useType: 2,
        scimg: station, xcimg: xcPlace, cityId: '',
        useTimeName: `${Default_DATE.monDayWeek} ${Default_DATE.hm}`,
        useTime: `${Default_DATE.date} ${Default_DATE.hm}`,
        voyage: '',
        desc: '',
        scdd: '', xcdd: '',
        terminal: '',
        sclocation: { lat: '', lng: '' },
        xclocation: { lat: '', lng: '' }
      },
      //送站
      sendingStation: {
        placeholder: '在哪儿上车',
        holder: this.$t('J232', '请选择出发站点'),
        tips: this.$t('J232', '请选择出发站点'),
        img: station,
        useType: 3,
        xcimg: station,
        scimg: xcPlace,
        cityId: '',
        useTimeName: `${Default_DATE.monDayWeek} ${Default_DATE.hm}`,
        useTime: `${Default_DATE.date} ${Default_DATE.hm}`,
        voyage: '', desc: '', scdd: '',
        xcdd: '', terminal: '',
        sclocation: { lat: '', lng: '' },
        xclocation: { lat: '', lng: '' }
      },
      //包车
      charteredCar: {
        placeholder: this.$t('J229', '您从哪儿出发'),
        holder: this.$t('J234', '请选择用车城市'),
        tips: this.$t('J235', '请选择出发地点'),
        img: scPlace,
        useType: 4, useDays: 1, scimg: scPlace, xcimg: xcPlace,
        cityId: '',
        useTimeName: `${Default_DATE.monDayWeek} ${Default_DATE.hm}`,
        useTime: `${Default_DATE.date} ${Default_DATE.hm}`,
        voyage: '', desc: '', scdd: '', xcdd: '', terminal: '',
        departCityName: '',
        departCity: '',
        sclocation: { lat: '', lng: '' },
        xclocation: { lat: '', lng: '' }
      },
      // 即时用车
      realTimeCar: {
        fun: 'jsycCar',
        placeholder: this.$t('J229', '您从哪儿出发'),
        holder: this.$t('J228', '您要去哪儿'),
        img: flightNo,
        useType: 5,
        departCity: '', arriveCity: '', fromAddress: '', fromAddressName: '', fromLon: '',
        fromLat: '', toAddress: '', toAddressName: '', toLon: '', toLat: '',
        useTimeName: `${Default_DATE.monDayWeek} ${Default_DATE.hm}`,
        useTime: `${Default_DATE.date} ${Default_DATE.hm}`,
        flag: 1, // 标识即时用车正在选择出发还是到达的地点
      },
      myFlightData: [], //航班列表
      siteParams: {
        //上下车地点选择 参数
        cityName: '',
        keywords: ''
      },
      showSite: false,
      cityType: 0, //
      showTerminal: false, //航站楼选择
      terminal: [], //航站楼集合
      minDate: new Date(),
      maxDate: new Date(formatDate(new Date(), 30).date3),
      myflt: false,
      mapInstance: {},
      jsycingOrder: null,
      jsycType: 8, // 即时用车类型 8即时 9预约
      ccsqdParams: { 'cplx': $dict.PRO_TYPE.car },//出差申请单入参
      ccsqd: {//出差单信息
        personList: [],//申请单出行人列表
      },
      didi: { linkUrl: '', baseURL: 'https://open.es.xiaojukeji.com' },
      cityId: '',
      cityName: '',
      beforeRouteLeaveCancelParams: [
        '$refs.queryFlights.isShow',
      ],
      carProType: [1, 1, 1, 1],
      city: [],
      jumpCar: { isJump: false },
      airportDropOffTime: '',
      descShow: true, // 送机的下车地点是否展示desc
      carType: '',
      Selfservice: false
    }
  },
  async created() {
    await this.queryCarProType()

    await this.querySelfservice()
    this.$store.commit('SET_SERVICE', { cplx: $dict.PRO_TYPE.car })
    this.$store.commit('car/CLEAR_ALL')

    if (this.$route.query.name) {
      this.name = this.$route.query.name
      this.changeTabs(this.$route.query.name)
    }

    // // 机票订单直跳订车
    // console.log('useType -> ' + this.$route.query.useType)
    // console.log('flight  -> ' + this.$route.query.flight)
    // if (this.$route.query.useType && this.$route.query.flight) {
    // 	this.jumpCar.isJump = true
    // 	this.useType = this.$route.query.useType
    // 	this.changeTab(this.useType)
    // 	this.getFlight(JSON.parse(this.$route.query.flight))
    // }
    this.flightOrder()

    if (this.serviceCtrl.isShowCcsqd) {
      let ccsqdId = this.$route.query.ccsqdId
      if (ccsqdId) {
        this.$api['common/vipCcsqdGetListForChoose']({
          ccsqdId: ccsqdId,
          proType: $dict.PRO_TYPE.car
        }).then(res => {
          var cache = res.data || []
          if (cache.length > 0) {
            this.ccsqdSelect(cache[0])
          } else {
            this.$toast('未查询到申请单信息')
          }
        })
      }
    }

    if (this.travelerList.length == 0) {
      this.$store.commit('car/travelerList', [{ ...this.userInfo.empInfo, clkFlag: 2 }])
    }

    this.queryWillPay()
    this.queryJsycing()
    this.getBusiness()
  },
  mounted() {
    setTimeout(() => {
      this.appGps('init')
    }, 1000)

    // var ssoParam = {
    // 	useType: 5, // 送机: 4 接机: 5 即时: 8 预约: 9
    // 	tripType: 1, // 因公因私 1 - 因公 2 - 因私
    // 	canModify: false, // 是否可以修改用车信息(手机号，出发到达地，机场等全部信息)
    // 	limitAmount: 100, // 订单金额上限
    // 	departAirport: 'XIY',
    // 	departAirportName: '咸阳国际机场',
    // 	departTerminal: 'T2',
    // 	departTime: '2021-01-09 20:30',
    // 	arriveAirport: 'PEK',
    // 	arriveAirportName: '首都国际机场',
    // 	arriveTerminal: 'T3',
    // 	arriveTime: '2021-01-09 22:45',
    // 	flightNo: 'CA1236',
    // 	departCity: '10119',
    // 	departCityName: '西安',
    // 	arriveCity: '10119',
    // 	arriveCityName: '北京',
    // 	empName: '钟离', // 出行人
    // 	phoneNumber: '13580115278',
    // 	empId: '',
    // 	extraInfo: '', //扩展信息 下单时需要
    // }

    let ssoParam = this.userInfo.empInfo.ssoJsonParam && JSON.parse(this.userInfo.empInfo.ssoJsonParam).vehiclesData
    if (ssoParam) {

      let DepartTime_DATE = formatDate(ssoParam.departTime)
      ssoParam.departDate = DepartTime_DATE.date
      ssoParam.departTime = DepartTime_DATE.hm

      let ArriveTime_DATE = formatDate(ssoParam.arriveTime)
      ssoParam.arriveDate = ArriveTime_DATE.date
      ssoParam.arriveTime = ArriveTime_DATE.hm

      if (ssoParam.useType == 4) {
        this.name = '0'
        this.changeTabs(this.name)
        this.changeTab(0)

        if (ssoParam.canModify === false) {
          this.airportPickup.flightDisabled = true
        }

        this.airportPickup.useTime = ssoParam.arriveDate
        this.getFlight(ssoParam)
      } else if (ssoParam.useType == 5) {
        this.name = '0'
        this.changeTabs(this.name)
        this.changeTab(1)

        if (ssoParam.canModify === false) {
          this.airportDropOff.flightDisabled = true
        }
        this.getFlight(ssoParam)

        // this.airportDropOff.useTimeName = ''
        this.selectDate({
          date: DepartTime_DATE.date,
          hm: '06:00',
          monDayWeek: `${DepartTime_DATE.monDay} ${DepartTime_DATE.week}`,
        })
      } else if (ssoParam.useType == 8 || ssoParam.useType == 9) {
        this.name = '3'
        this.changeTabs(this.name)
      }

      this.$store.commit('car/travelerList', [{
        empId: ssoParam.empId,
        empName: ssoParam.empName,
        phoneNumber: ssoParam.phoneNumber,
      }])
      this.$store.commit('SET_TRIPTYPE', ssoParam.tripType)
      this.carSearchInfo.disabledModify = ssoParam.canModify ? false : true
      this.carSearchInfo.limitAmount = ssoParam.limitAmount
      this.carSearchInfo.extraInfo = ssoParam.extraInfo
    }

  },
  computed: {
    ...mapGetters({
      tripType: 'tripType',
      userInfo: 'userInfo',
      serviceCtrl: 'serviceCtrl',
      carSearchInfo: 'car/carSearchInfo',
      travelerList: 'car/travelerList'
    }),
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    if (to.name == 'home') {
      this.$store.commit('car/CLEAR_ALL')
    }

    if (this.$refs['queryFlights'].isShow) {
      this.$refs['queryFlights'].toggle()
      history.pushState(null, null, `${document.location.origin}/#${this.$route.fullPath}`)
    } else {
      window.removeEventListener('popstate', forbidBack)
      next()
    }

  },
  beforeRouteEnter(to, from, next) {
    next(vm => {// 通过 `vm` 访问组件实例
      let historyLog = localget('_historyLog')
      if (historyLog) {
        if (historyLog.car) {
          // 历史查询记录的时间已经过了当前时间，就把历史查询的时间记录清空，默认时间为明天
          if (historyLog.car.airportPickup) {
            if (formatDate(new Date()).date > historyLog.car.airportPickup.useTime) {
              Object.assign(historyLog.car.airportPickup, {
                useTimeName: `${Default_DATE.monDayWeek} ${Default_DATE.hm}`,
                useTime: `${Default_DATE.date} ${Default_DATE.hm}`
              })
            }
            Object.assign(vm.airportPickup, historyLog.car)
          }
          vm.useType = historyLog.car.useType || 0
        }
      }
    })
  },
  methods: {
    ...mapActions(['getBusiness']),
    async getPoint() {
      this.loadMap()
    },
    loadMap(point) {
      this.mapInstance = new AMap({
        id: 'carQueryMap',
        zoom: 16,
        center: point,
        plugins: ['AMap.Geolocation'],
        AMapUIPlugins: ['misc/PositionPicker'],
        created: () => {

        },
        completed: () => {
        },
        error: err => {
          console.log(err)
          this.$toast.fail('定位失败')
        },
        moveend: this.moveend
      })

    },
    async moveend(point) {
      this.realTimeCar.fromAddressName = '正在获取上车地点...'
      const { data = {} } = await this.geocoder(point.position, this)
      this.realTimeCar.fromLat = point.position.lat
      this.realTimeCar.fromLon = point.position.lng
      this.realTimeCar.fromAddressPoi = point.regeocode.aois[0] ? point.regeocode.aois[0].name : point.nearestPOI
      // 待定
      this.realTimeCar.fromArea = point.regeocode.addressComponent.district
      this.realTimeCar.fromAddress = point.regeocode.pois[0] ? point.regeocode.pois[0].name : point.nearestPOI
      this.realTimeCar.fromAddressName = this.realTimeCar.fromAddress
      this.realTimeCar.departCity = data.cityId
      this.realTimeCar.confirmCityId = data.city
      this.realTimeCar.confirmCityName = data.city
      this.$forceUpdate()
    },
    stepperChange() {
      if (this.realTimeCar.useDays > 1) {
        this.realTimeCar.useDays = parseInt(this.realTimeCar.useDays)
      }
    },
    vaild() {
      if (this.serviceCtrl.isShowCcsqd && !this.carSearchInfo.Ccsqd.ccsqdNo) {
        this.$toast('请选择出差申请单')
        return
      }

      // 0 接机 1 送机 2接站 3送站 4包车 5即时用车
      //验证是否已有城市数据
      if (this.useType == 0) {
        if (!this.airportPickup.scdd) {
          if (this.airportPickup.voyage == '') {
            this.$toast('请选择到达机场')
            return
          } else {
            this.$toast('查询失败')
            return
          }
        } else if (!this.airportPickup.xcdd) {
          this.$toast('请选择下车地点')
          return
        }
      } else if (this.useType == 1) {
        if (!this.airportDropOff.xcdd) {
          if (this.airportDropOff.voyage == '') {
            this.$toast('请选择出发机场')
            return
          } else {
            this.$toast('查询失败')
            return
          }
        } else if (!this.airportDropOff.scdd) {
          this.$toast('请选择上车地点')
          return
        }
      } else if (this.useType == 2) {
        if (!this.receivingStation.scdd) {
          this.$toast('请选择到达站点')
          return
        } else if (!this.receivingStation.xcdd) {
          this.$toast('请选择下车地点')
          return
        } else if (!this.receivingStation.useTime) {
          this.$toast('请选择用车时间')
          return false
        }
      } else if (this.useType == 3) {
        if (!this.sendingStation.xcdd) {
          this.$toast('请选择出发站点')
          return
        } else if (!this.sendingStation.scdd) {
          this.$toast('请选择上车地点')
          return
        } else if (!this.sendingStation.useTime) {
          this.$toast('请选择用车时间')
          return false
        }
      } else if (this.useType == 4) {
        if (!this.charteredCar.useTime) {
          this.$toast('请选择用车时间')
          return false
        }
      }

      var name = useType[this.useType]
      let useTime = this[name].useTime
      if (useTime && useTime.indexOf(':') > -1) {//兼容ios浏览器
        useTime = useTime + ':00'
        useTime = useTime.replace(/-/g, '/')
      }
      if (this.useType == 0 || this.useType == 1 || this.useType == 2 || this.useType == 3) {
        if (getDiffHour(useTime, new Date()) <= 2) {
          this.$toast('最少需要提前2小时预订')
          // return false
        }
      } else if (this.useType == 4) {
        if (getDiffHour(useTime, new Date()) <= 4) {
          this.$toast('最少需要提前4小时预订')
          // return false
        }
      }
      return true
    },
    confirmCitySelected(info) {
      this.realTimeCar.confirmCityName = info.cityName
      this.realTimeCar.confirmCityId = info.cityId
      this.$forceUpdate()
    },
    // 即时用车 - 确认上车地点 点返回
    confirmScddBack() {
      this.$refs['carDriving'].show = true
      this.cardShow = true
      this.confirmPullupPopup = false
    },
    // 即时用车 - 确认上车地点
    changeFromAddress() {
      this.cardShow = false
      this.confirmPullupPopup = true
      this.realTimeCar.confirmCityName = this.realTimeCar.cityName
      this.realTimeCar.confirmCityId = this.realTimeCar.cityId
    },
    async jsycSite(info) {
      // 传入的经纬度是百度坐标系，下面需转换为高德所用的火星坐标系
      const { lng, lat } = await AMap.convertFrom([info.location.lng, info.location.lat], 'baidu')
      if (this.realTimeCar.flag == 1) {
        this.mapInstance.dragMapStop()
        this.realTimeCar.fromLat = lat
        this.realTimeCar.fromLon = lng
        this.realTimeCar.fromAddressPoi = info.name
        this.realTimeCar.fromArea = info.address
        this.realTimeCar.fromAddress = info.address
        this.realTimeCar.fromAddressName = info.name
        this.realTimeCar.departCity = info.siteCityId
        this.realTimeCar.departCityName = info.siteCityName
        this.realTimeCar.cityId = info.siteCityId
        this.realTimeCar.cityName = info.siteCityName
        this.mapInstance.setCenter([lng, lat], '', true)
        setTimeout(() => {
          this.mapInstance.dragMapStart()
        }, 500)
      } else {
        // 地图要用火星坐标系定位
        this.realTimeCar.toLat = lat
        this.realTimeCar.toLon = lng
        // 接口为百度的接口，需要传百度的经纬度查 经纬度的地标等信息
        const { data = {} } = await this.geocoder(info.location)
        this.realTimeCar.arriveCity = data.cityId
        this.realTimeCar.arriveCityName = data.city
        this.realTimeCar.toAddressPoi = info.name
        this.realTimeCar.toArea = info.district
        this.realTimeCar.toAddress = info.address || info.name
        this.realTimeCar.toAddressName = info.name
      }
      // 如果及时用车的价格查询页是显示的 修改了上下车地点需要重新查询
      if (this.$refs['carDriving'].show) {
        this.searchJsyc('')
      }
      this.$forceUpdate()
    },
    // 查询结束服务未支付的订单
    async queryWillPay() {
      const { data = {} } = await this.$api['carQuery/checkPreBook']()
      if (data.orderId && data.orderFlag == 2) {
        this.$dialog.confirm({
          message: '您有一个已结束服务未支付的订单，请先进行支付！',
          showCancelButton: false
        }).then(() => {
          this.$router.push({ path: '/car/carOrderDetail', query: { orderId: data.orderId } })
        })
      }
    },
    // 查询正在进行中的即时用车订单
    async queryJsycing() {
      const { data = {} } = await this.$api['carQuery/checkPreBook']({
        orderType: '8'
      })
      this.jsycingOrder = data.orderId ? data : null
    },
    //获取根据11604005数值，后端接口查询出来的value1的值
    async queryCarProType() {
      await queryVipParameter('11604005').then(res => {
        if (res.value1) {
          this.carProType = res.value1.split(',')
        }
      })
    },
    //获取根据20034数值，获取是否可自选航航班
    async querySelfservice() {
      await getParameter('20034').then(res => {
        if (res.value1 == 1) {
          this.Selfservice = false
        } else {
          this.Selfservice = true
        }
      })
    },
    // 即时用车查询 or 传入id 查看正在进行的即时用车订单
    searchJsyc(id) {
      if (localStorage.getItem("home")) {
        localStorage.removeItem('home');
      }
      this.cardShow = true
      this.confirmPullupPopup = false
      this.toggle('carDriving', {
        id,
        useType: this.jsycType,
        show: true
      })
    },
    async search() {
      // 查车
      if (this.useType == 1) {
        if (this.airportDropOff.useTime && this.airportDropOff.useTime.indexOf(':') < 0) {
          if (this.airportDropOff.arriveTimes) {
            this.airportDropOff.useTime = this.airportDropOff.useTime + ' ' + this.airportDropOff.departTimes
          }
        }
      } else if (this.useType == 0) {
        if (this.airportPickup.useTime) {
          if (this.airportPickup.useTime.indexOf(':') < 0) {
            if (this.airportPickup.departTimes) {
              this.airportPickup.useTime = this.airportPickup.useTime + ' ' + this.airportPickup.arriveTimes
            } else {
              this.airportPickup.useTime = this.airportPickup.useTime + ' ' + this.airportPickup.arriveTime
            }
          }
        } else {
          if (this.airportPickup.departTimes) {
            this.airportPickup.useTime = this.airportPickup.arriveDate + ' ' + this.airportPickup.arriveTimes
          } else {
            this.airportPickup.useTime = this.airportPickup.arriveDate + ' ' + this.airportPickup.arriveTime
          }
        }
      }

      if (this.vaild()) {
        var car = {
          airportPickup: this.airportPickup,
          airportDropOff: this.airportDropOff,
          receivingStation: this.receivingStation,
          sendingStation: this.sendingStation,
          charteredCar: this.charteredCar,
          realTimeCar: this.realTimeCar,
          useType: this.useType,
        }
        let historyLog = localget('_historyLog')
        if (!historyLog) {
          historyLog = { car: car }
        }
        if (!historyLog.car) {
          historyLog.car = car
        }
        localset('_historyLog', historyLog)
        var name = useType[this.useType]
        // 传入的经纬度是百度坐标系，下面需转换为高德所用的火星坐标系
        const { lng, lat } = await AMap.convertFrom([this[name].sclocation.lng, this[name].sclocation.lat], 'baidu')
        if (lng && lat) {
          this[name].sclocation.lat = lat
          this[name].sclocation.lng = lng
        }
        if (this.useType != 4) {
          const {
            lng: xclng,
            lat: xclat
          } = await AMap.convertFrom([this[name].xclocation.lng, this[name].xclocation.lat], 'baidu')
          // 地图要用火星坐标系定位
          if (xclng && xclat) {
            this[name].xclocation.lat = xclat
            this[name].xclocation.lng = xclng
          }
        }


        var param = { useType: this.useType }
        //如果是从机票订单中跳转过来的参数进行特殊处理
        if (this.jumpCar.isJump) {
          var routerFlight = JSON.parse(this.$route.query.flight)
          var useTime = routerFlight.arriveDate + ' ' + routerFlight.arriveTime
          param = {
            useType: this.useType,
            departCity: routerFlight.departCityId,
            useTime: useTime
          }
        }

        //this.useType == 1 是送机,送机不进入下面这个方法里
        if (this.useType == 0 && !this[name].scdd.includes('T')) {
          if (this[name].arriveTerminal != undefined) {
            this[name].scdd = this[name].arriveAirportName + this[name].arriveTerminal
          }
        }
        this.$store.commit('car/carSearchInfo', Object.assign(this.carSearchInfo, this[name], param))
        this.$router.push({ path: '/car/carList' })
      }
    },
    //查询航班
    queryFlights(param, date) {
      this.myflt = false
      var name = ''
      if (this.useType == 0) {//接机
        name = 'airportPickup'
      } else if (this.useType == 1) {//送机
        name = 'airportDropOff'
      }
      if (this[name].arriveTime) {
        this[name].useTime = date + ' ' + this[name].arriveTime
      } else {
        this[name].useTime = date
      }
      this.myFlightData = param
      this.toggle('myFlights', { data: param, date: date })
    },
    // 我的航班 获取系统内机票订单
    myFlight(ywlx) {
      //因公模式下选有公出单再点可以点击航班
      if (this.userInfo.vipCorp.bookStyle == 2 && this.tripType == 1 && !this.carSearchInfo.Ccsqd.ccsqdNo) {
        this.$toast('请先选择公出单')
        return
      }
      this.descShow = false
      let param = {
        ywlx: ywlx,
        ccsqdNo: (this.carSearchInfo && this.carSearchInfo.Ccsqd) ? this.carSearchInfo.Ccsqd.ccsqdNo : ''
      }
      this.myflt = true
      //业务类型 1接机 2送机 不能为空
      this.$api['common/queryWcxOrder'](param).then(res => {
        let cache = res.data || []
        cache.reverse()
        if (cache.length > 0) {
          this.myFlightData = cache
          this.toggle('myFlights')
        } else {
          this.$toast('未查询到您的航班信息')
        }
      })
    },
    // 检索 按照站点名称 全拼 首字母 和 城市名称来搜索  0 机票 1 酒店 2火车站
    getResultData(val) {
      let arr = []
      let reg = new RegExp('^' + val, 'gim')
      let reg1 = new RegExp('^' + val + '$', 'gim')

      for (let k in this.city) {
        if (arr.length < 12) {
          let city = this.city[k] || []
          for (let i = 0; i < city.length; i++) {
            let bl = false
            for (let k in city[i]) {
              var cache = city[i][k] || ''
              if (cache && typeof (cache) == 'string') {
                if (cache.match(reg1)) {
                  arr.push(city[i])
                  bl = false
                  break
                } else if (cache.match(reg)) {
                  bl = true
                }
              }
            }
            if (bl) {
              arr.push(city[i])
            }
          }
        }
      }
      return arr
    },
    getFightCities() {
      //机票城市机场数据
      let cplx = '10901'
      this.$refs.city.getCityList(cplx)
      let local = this.$i18n.locale()// 'zh-CN' 'en-US'
      let obj = {
        '10901': 'geo_10901_' + local,
        '10903': 'geo_10903_' + local,
        '10904': 'geo_10904_' + local,
        '10910': 'geo_10910_' + local,
        '10906': 'geo_10906_' + local,
      }
      let url = obj[cplx]
      let cache = ''
      try {
        cache = localget(url)
      } catch (e) {
        console.error(e.message)
      }
      return cache
    },
    getPreciseCity(cityName, airportName) {
      let cities = this.getFightCities()
      this.city = cities
      let preciseCity = this.getResultData(cityName)
      if (preciseCity.length > 0) {
        preciseCity.forEach(r => {
          if (r.jcZdName === airportName) {
            this.jumpCar.city = r
          }
        })
      }
    },
    // 航班回调
    getFlight(item, date) {
      if (item.departTime.includes('/') || item.departTime.includes('-')) {
        //   this.airportDropOff.useTimeName = getPreStrTime(item.departTime, -2).slice(0, 16)
        this.airportDropOff.useTimeName = item.departTime
      } else {
        item.departTime = `${item.departDate} ${item.departTime}`
        //  this.airportDropOff.useTimeName = getPreStrTime(item.departTime, -2).slice(0, 16)
        this.airportDropOff.useTimeName = item.departTime
      }
      if (this.useType == 1) {  //送机时生效
        //这二个只需要送机
        if (!item.arriveCity && item.arriveCityId) {
          item.arriveCity = item.arriveCityId
        }
        if (!item.departCity && item.departCityId) {
          item.departCity = item.departCityId
        }
      }
      this.airportDropOffTime = formatDate(this.airportDropOff.useTimeName).monDay + ' ' + formatDate(this.airportDropOff.useTimeName).week + ' ' + formatDate(this.airportDropOff.useTimeName).hm
      this.airportDropOff.useTime = item.departTime
      if (this.useType == 0) {//接机
        this.getPreciseCity(item.arriveCityName, item.arriveAirportName)
        if (!item.arriveAirport) {
          item.arriveAirport = this.jumpCar.city.jcZdCode
        }

        this.airportPickup.departAirport = item.departAirport
        this.airportPickup.departAirportName = item.departAirportName
        this.airportPickup.departTerminal = item.departTerminal
        this.airportPickup.arriveAirport = item.arriveAirport
        this.airportPickup.arriveAirportName = item.arriveAirportName
        this.airportPickup.arriveTerminal = item.arriveTerminal

        this.airportPickup.flightNo = item.flightNo
        this.airportPickup.departTime = item.departTime
        this.airportPickup.arriveTime = item.arriveTime

        this.airportPickup.useTime = date

        console.log(this.airportPickup.useTime, item.arriveTime)
        if (item.arriveTime.length === 5) {
          this.airportPickup.useTime = `${this.airportPickup.useTime} ${item.arriveTime}`.substring(0, 16)
        } else {
          this.airportPickup.useTime = item.arriveTime
        }
        console.log(this.airportPickup.useTime)
        this.airportPickup.departCity = item.arriveCity
        this.airportPickup.departCityName = item.arriveCityName
        this.getLatlng(item.arriveCityName, item.arriveAirportName).then(res => {
          this.airportPickup.scdd = res.name
          this.airportPickup.scaddress = res.address
          this.airportPickup.sclocation.lat = res.location.lat
          this.airportPickup.sclocation.lng = res.location.lng
        })

        this.airportPickup.voyage = `${item.arriveCityName} - ${this.airportPickup.arriveAirportName}  ${this.airportPickup.arriveTerminal || ''}`
        this.airportPickup.desc = `${this.airportPickup.flightNo}  ${formatDate(item.arriveDate || this.airportPickup.useTime).monDay} ${item.arriveTimes || item.arriveTime} 到达`
      } else if (this.useType == 1) {// 送机
        this.getPreciseCity(item.departCityName, item.departAirportName)
        if (!item.departAirport) {
          item.departAirport = this.jumpCar.city.jcZdCode
        }

        this.airportDropOff.departAirport = item.departAirport
        console.log(item.departAirportName, 'item.departAirportName')
        this.airportDropOff.departAirportName = item.departAirportName
        this.airportDropOff.departTerminal = item.departTerminal
        this.airportDropOff.arriveAirport = item.arriveAirport
        this.airportDropOff.arriveAirportName = item.arriveAirportName
        this.airportDropOff.arriveTerminal = item.arriveTerminal
        this.airportDropOff.flightNo = item.flightNo
        this.airportDropOff.pnrNo = item.pnrNo
        this.airportDropOff.departTime = item.departTime
        this.airportDropOff.arriveTime = item.arriveTime

        // 机场 与 城市 数据分离  （城市数据代表 用车实际出发到达城市） 此处送机的到达城市应该是 起飞机场所在城市
        this.airportDropOff.arriveCity = item.departCity
        this.airportDropOff.arriveCityName = item.departCityName
        this.airportDropOff.departCityName1 = item.departCityName
        this.getLatlng(item.departCityName, item.departAirportName).then(res => {
          this.airportDropOff.xcdd = res.name
          this.airportDropOff.xcaddress = res.address
          this.airportDropOff.xclocation.lat = res.location.lat
          this.airportDropOff.xclocation.lng = res.location.lng
        })

        if (item.arriveDate) this.airportPickup.arriveDate = item.arriveDate
        this.airportDropOff.voyage = `${item.departCityName} - ${item.departAirportName}  ${item.departTerminal || ''}`
        this.airportDropOff.desc = `${this.airportDropOff.flightNo}  ${formatDate(item.departDate || this.airportDropOff.useTime).monDay} ${item.departTimes || item.departTime} 出发`
      }
    },
    // 机票订单直跳订车
    flightOrder() {

      let useType = this.$route.query.useType ? this.$route.query.useType : localget('voyage_useType')
      let flight = this.$route.query.flight ? this.$route.query.flight : localget('voyage_flight')
      if (useType && flight) {
        localremove('voyage_useType')
        localremove('voyage_flight')

        this.useType = useType
        this.jumpCar.isJump = true
        this.changeTab(this.useType)

        // if (localget('refresh_the_page')) {
        //   localremove('refresh_the_page');
        //   this.$router.go(0);
        // }

        this.getFlight(JSON.parse(flight))
      }
    },
    //航站楼
    queryApTrnInfo(jcZdCode) {
      if (!jcZdCode) return
      this.$api['carQuery/queryApTrnInfo']({ threeCode: jcZdCode }).then(
        res => {
          let cache = res.data || []
          if (cache.length > 0) {
            cache.forEach(ele => {
              ele.text = ele.terminalName || '暂无其他航站楼'
            })
            this.terminal = cache
            console.log(cache, 'cache')
          }
        }
      )
    },
    // 航站楼回调
    selectTerminal(item) {
      this.showTerminal = false
      this.airportDropOff.departTerminal = item.terminal
      this.airportDropOff.departTerminalName = item.terminalName
    },
    //选择机场 车站 城市
    chooseCity() {
      //判断已开启不可以自选，因公
      if (this.Selfservice && this.name == "0") {
        this.$dialog({
          message: '接送机不可自选航班，请点击我的航班进行操作',
        }).then(() => {
        })
        return
      }
      if (this.useType == 0) {
        this.cityType = 0 //机场
        this.toggle('queryFlights')
      } else if (this.useType == 1) {
        this.descShow = true
        this.cityType = 0 //机场
        this.$refs.city.toggle({ cityType: 0 })
      } else if (this.useType == 4) {
        this.cityType = 1 //城市
        this.$refs.city.toggle({ cityType: 4 })
      } else {
        this.cityType = 2 //火车站
        this.$refs.city.toggle({ cityType: 2 })
      }
    },
    // 手动选择机场 /城市 回调
    getCity(item) {
      console.log(item)
      if (this.useType == 1) {//送机
        this.airportDropOff.departAirport = item.jcZdCode
        console.log('item.jcZdName', item.jcZdName)
        this.airportDropOff.departAirportName = item.jcZdName
        this.airportDropOff.arriveCity = item.cityId
        this.airportDropOff.arriveCityName = item.cityName
        console.log('this.getLatlng', item.cityName, item.jcZdName)
        this.getLatlng(item.cityName, item.jcZdName).then(res => {
          this.airportDropOff.xcdd = res.name
          this.airportDropOff.xcaddress = res.address
          this.airportDropOff.xclocation.lat = res.location.lat
          this.airportDropOff.xclocation.lng = res.location.lng
        })
        this.airportDropOff.voyage = `${this.airportDropOff.arriveCityName} - ${this.airportDropOff.departAirportName}`
        this.airportDropOff.desc = `${(this.airportDropOff.flightNo || '')}  ${formatDate(this.airportDropOff.departDate || this.airportDropOff.useTime).monDay} ${(this.airportDropOff.departTimes || this.airportDropOff.departTime || '')} 出发`
        console.log(this.airportDropOff, '0000')
        this.queryApTrnInfo(item.jcZdCode)
      } else if (this.useType == 2) {//接站
        this.receivingStation.arriveAirport = item.jcZdCode || item.zddm
        this.receivingStation.arriveAirportName = item.jcZdName || item.zdmc
        this.receivingStation.departCity = item.cityId
        this.receivingStation.departCityName = item.cityName
        this.getLatlng(item.cityName, this.receivingStation.arriveAirportName).then(res => {
          console.log(res)
          this.receivingStation.scdd = res.name
          this.receivingStation.scaddress = res.address
          this.receivingStation.sclocation.lat = res.location.lat
          this.receivingStation.sclocation.lng = res.location.lng
        })
      } else if (this.useType == 3) {//送站
        this.sendingStation.departAirport = item.jcZdCode || item.zddm
        this.sendingStation.departAirportName = item.jcZdName || item.zdmc
        this.sendingStation.arriveCity = item.cityId
        this.sendingStation.arriveCityName = item.cityName
        this.getLatlng(item.cityName, this.sendingStation.departAirportName).then(res => {
          console.log(res)
          this.sendingStation.xcdd = res.name
          this.sendingStation.xcaddress = res.address
          this.sendingStation.xclocation.lat = res.location.lat
          this.sendingStation.xclocation.lng = res.location.lng
        })
      } else if (this.useType == 4) {//包车
        this.charteredCar.departCity = item.cityId
        this.charteredCar.departCityName = item.cityName
        // this.getLatlng(item.cityName,item.cityName).then(res=>{
        // 	console.log(res)
        // 	this.charteredCar.xcdd=res.name
        // 	this.charteredCar.xcaddress=res.address
        // 	this.charteredCar.xclocation.lat=res.location.lat
        // 	this.charteredCar.xclocation.lng=res.location.lng
        // })
      }
    },
    //选择地点
    showingSite(flag) {
      this.carType = this.useType
      // 正常要带cityId, flag !=1 是专门给即时用车的出发地点的入口
      // if (!this.params.cityId && flag != 1) {
      if (this.useType == 0) {
        this.cityId = this.airportPickup.arriveCity || this.airportPickup.departCity || this.cityId
        this.cityName = this.airportPickup.arriveCityName || this.airportPickup.departCityName || this.cityName
      } else if (this.useType == 1) {
        this.cityId = this.cityId || this.airportPickup.departCity || this.airportPickup.arriveCity
        this.cityName = this.cityName || this.airportPickup.departCityName || this.airportPickup.arriveCityName
      } else if (this.useType == 2) {
        this.cityId = this.receivingStation.departCity || this.receivingStation.arriveCity || this.cityId
        this.cityName = this.receivingStation.departCityName || this.receivingStation.arriveCityName || this.cityName
      } else if (this.useType == 3) {
        this.cityId = this.cityId || this.airportPickup.departCity || this.airportPickup.arriveCity
        this.cityName = this.cityName || this.airportPickup.departCityName || this.airportPickup.arriveCityName
      } else if (this.useType == 4) {
        this.cityId = this.charteredCar.departCity || this.charteredCar.arriveCity || this.cityId
        this.cityName = this.charteredCar.departCityName || this.charteredCar.arriveCityName || this.cityName
      } else if (this.useType == 5) {
        this.cityId = this.charteredCar.departCity || this.charteredCar.arriveCity || this.cityId
        this.cityName = this.charteredCar.departCityName || this.charteredCar.arriveCityName || this.cityName
      }
      // 	return
      // }
      this.showSite = true
      this.realTimeCar.flag = flag
    },
    // 地点选择 回调
    getSite(item) {
      if (this.useType == 0) {//接机
        this.airportPickup.xcdd = item.name
        this.airportPickup.xcaddress = item.address
        this.airportPickup.xclocation.lat = item.location.lat
        this.airportPickup.xclocation.lng = item.location.lng
        this.airportPickup.arriveCity = item.siteCityId
        this.airportPickup.arriveCityName = item.siteCityName
      } else if (this.useType == 1) {//送机
        this.airportDropOff.scdd = item.name
        this.airportDropOff.scaddress = item.address
        this.airportDropOff.sclocation.lat = item.location.lat
        this.airportDropOff.sclocation.lng = item.location.lng
        this.airportDropOff.departCity = item.siteCityId
        this.airportDropOff.departCityName = item.siteCityName
      } else if (this.useType == 2) {//接站
        this.receivingStation.xcdd = item.name
        this.receivingStation.xcaddress = item.address
        this.receivingStation.xclocation.lat = item.location.lat
        this.receivingStation.xclocation.lng = item.location.lng
        this.receivingStation.arriveCity = item.siteCityId
        this.receivingStation.arriveCityName = item.siteCityName
      } else if (this.useType == 3) {
        this.sendingStation.scdd = item.name
        this.sendingStation.scaddress = item.address
        this.sendingStation.sclocation.lat = item.location.lat
        this.sendingStation.sclocation.lng = item.location.lng
        this.sendingStation.departCity = item.siteCityId
        this.sendingStation.departCityName = item.siteCityName
      } else if (this.useType == 4) {
        this.charteredCar.scdd = item.name
        this.charteredCar.scaddress = item.address
        this.charteredCar.sclocation.lat = item.location.lat
        this.charteredCar.sclocation.lng = item.location.lng
        this.charteredCar.departCity = item.siteCityId
        this.charteredCar.departCityName = item.siteCityName
      }
      this.cityId = item.siteCityId
      this.cityName = item.siteCityName
    },
    // 关闭地点选择
    hideSite() {
      this.showSite = false
    },
    //出差申请单信息
    ccsqdSelect(info) {
      this.carSearchInfo.Ccsqd = info
    },
    //获取当前用户的所在位置信息
    appGps(init) {
      var self = this

      if (this.useType == 1) {
        this.airportDropOff.scdd = '正在获取当前位置...'
      } else if (this.useType == 3) {
        this.sendingStation.scdd = '正在获取当前位置...'
      }
      amap.load(() => {
        amap.appGps().then(point => {

          if (point) {
            var coords = point.coords || {}
            var locat = {
              lng: coords.longitude || point.lng || '',
              lat: coords.latitude || point.lat || ''
            }
            this.geocoder(locat, true).then(res => {
              var cache = res.data || {}
              if (init && typeof init === 'string') {
                this.cityId = cache.cityId
                this.cityName = cache.city
              } else {
                if (self.useType == 1) {//送机
                  this.airportDropOff.departCity = cache.cityId
                  this.airportDropOff.departCityName = cache.city
                  this.airportDropOff.sclocation.lat = locat.lat
                  this.airportDropOff.sclocation.lng = locat.lng
                  if (cache.street) {
                    this.airportDropOff.scaddress = ((cache.street || '') + (cache.streetNumber || '')) || cache.formattedAddress || ''
                  } else {
                    this.airportDropOff.scaddress = cache.formattedAddress || cache.city
                  }

                  this.airportDropOff.scdd = cache.business.split(',')[0] || cache.city
                  if (cache.poiList && cache.poiList[0]) {
                    this.airportDropOff.scdd = cache.poiList[0].name
                  }
                } else if (self.useType == 3) {//送站
                  this.sendingStation.departCity = cache.cityId
                  this.sendingStation.departCityName = cache.city
                  this.sendingStation.sclocation.lat = locat.lat
                  this.sendingStation.sclocation.lng = locat.lng
                  if (cache.street) {
                    this.sendingStation.scaddress = ((cache.street || '') + (cache.streetNumber || ''))
                  } else {
                    this.sendingStation.scaddress = cache.formattedAddress || cache.city
                  }
                  this.sendingStation.scdd = cache.business.split(',')[0] || cache.city
                  if (cache.poiList && cache.poiList[0]) {
                    this.sendingStation.scdd = cache.poiList[0].name
                  }
                }

                this.$forceUpdate()
              }
            })
          } else {
            this.$toast('定位失败, 请手动选择城市！')
          }
        })

      })
    },
    //选择用车时间回调
    selectDate(date, index) {
      // 0 接机 1 送机 2接站 3送站 4包车 5即时用车
      console.log(date, 'date')
      console.log(this.useType, 'this.useType')
      let params = {
        useTimeName: `${date.monDayWeek} ${date.hm}`,
        useTime: `${date.date} ${date.hm}`
      }
      if (this.useType == 1) {
        Object.assign(this.airportDropOff, params)
        this.airportDropOff.useTimeName = params.useTimeName
        this.airportDropOff.useTime = params.useTime
        if (!this.airportDropOff.desc.includes('undefined')) {
          this.airportDropOffTime = this.airportDropOff.useTimeName
          this.airportDropOff.useTimeName = params.useTime
        }
      } else if (this.useType == 2) {
        Object.assign(this.receivingStation, params)
        this.airportDropOff.useTimeName = params.departTime
        this.airportDropOff.useTime = params.useTime
      } else if (this.useType == 3) {
        Object.assign(this.sendingStation, params)
        this.airportDropOff.useTimeName = params.departTime
        this.airportDropOff.useTime = params.useTime
      } else if (this.useType == 4) {
        Object.assign(this.charteredCar, params)
        this.airportDropOff.useTimeName = params.departTime
        this.airportDropOff.useTime = params.useTime
      } else if (this.useType == 5) {
        Object.assign(this.realTimeCar, params)
        this.airportDropOff.useTimeName = params.departTime
        this.airportDropOff.useTime = params.useTime
      }

    },
    // 关键字 获取经纬度
    async getLatlng(cityName, keywords) {
      let { data = {} } = await this.$api['city/baiduPlace']({
        cityName: cityName,
        keywords: keywords
      })
      data.list = data.list || []
      if (data == {}) {
        this.$toast('查询失败')
        return false
      }
      let dataList = data.list.find(i => i.location)
      if (cityName == '重庆') {
        dataList = data.list.find(i => i.name == '重庆江北国际机场')
      }
      return dataList
    },
    /**
     * 根据经纬度 获取详细地址信息
     * @location { lat :'',lng:''}
     * @turn gcj02tobd09  转百度坐标
     * */
    async geocoder(location, turn) {
      if (!location.lng || !location.lat) {
        return {}
      }
      var params = location
      if (turn) {
        var arr = gcj02tobd09(location.lng, location.lat)//转为百度坐标
        params = { coordType: 'bd09ll', lat: arr[1], lng: arr[0] }
      } else {
        params = { coordType: 'bd09ll', lat: location.lat, lng: location.lng }
      }
      if (!params.lat) {
        return {}
      } else if (!params.lng) {
        return {}
      }
      let res = await this.$api['baidu/geocoder'](params)
      return res
    },
    //
    changeTabs(num) {
      var useType = [0, 2, 4, 5][num]
      if (useType == 5) {
        //跳小程序，行路的不跳
        console.log('哈哈哈')
        if (window.__wxjs_environment === 'miniprogram' && !isXlminp()) {
          console.log('呵呵呵')
          this.$nextTick(() => {
            this.name = '0'
            this.useType = 1
          })
          var paramspay = encodeURIComponent(JSON.stringify({ token: localget('access_token'), tripType: this.tripType }))
          wx.miniProgram.navigateTo({//
            url: '/pages/car/driving/index?query=' + paramspay,
            events: {
              // 为指定事件添加一个监听器，获取被打开页面传送到当前页面的数据
              acceptDataFromOpenedPage: function (data) {
                console.log(1, data)
              },
              someEvent: function (data) {
                console.log(2, data)
              }
            },
            success: function (res) {
              // 通过eventChannel向被打开页面传送数据
              res.eventChannel.emit('acceptDataFromOpenerPage', { data: paramspay })
            }
          })
        } else {
          if (num == 3 && !this.mapInstance.completed) {
            this.getPoint()
          }
          this.useType = useType
        }
      } else {
        if (num == 3 && !this.mapInstance.completed) {
          this.getPoint()
        }
        this.useType = useType
      }
    },
    changeTab(num) {
      this.useType = num
      if (this.useType == 1 || this.useType == 3) {
        this.appGps()
      }
    },
    toggle(name, params) {
      this.$refs[name].toggle(params)
    },
    //返回
    back() {
      if (isXlminp()) {
        return goXlHome()
      }
      this.$router.push({ path: '/home' })
    },
    // 滴滴单点登录
    didiSSO() {
      const params = {
        client_id: 'b0a6b65a842eb9dc87dea1550e4bccdc',
        auth_code: '',
      }
      // 选择了到达地点则要带参数传入
      if (this.realTimeCar.toAddressName) {
        // 如果是预约用车 带入预约时间
        let useTime = undefined
        if (this.jsycType == 9) {
          const date = formatDate(this.realTimeCar.useTime)
          useTime = `${date.week}|${date.hm}`
        }
        const otherParams = {
          city_id: '1', // 出发地城市 ID, 进入发单页面必传
          lat_from: this.realTimeCar.fromLat,
          lng_from: this.realTimeCar.fromLon,
          poi_from_name: this.realTimeCar.fromAddressPoi,
          to_city_id: '1',
          lat_to: this.realTimeCar.toLat,
          lng_to: this.realTimeCar.toLon,
          poi_to_name: this.realTimeCar.toAddressPoi,
          appointment_time: useTime, // 预约用车时间
          jumpPage: USETYPE_JUMPPAGE[this.jsycType],
          scene_id: 3
        }
        this.didi.linkUrl = `${this.didi.baseURL}/webapp/feESWebappLogin/index?${objectToQueryString({ ...params, ...otherParams })}`
      } else {
        this.didi.linkUrl = `${this.didi.baseURL}/webapp/feESWebappLogin/index`
      }
      openWebview(this.didi.linkUrl, 'didipage')
    },
    toOrderList() {
      this.$store.commit('SET_ORDERLISTPARAMS', {
        findType: 1,
        productType: $dict.PRO_TYPE.car
      })
      this.$router.push('/allOrder?findType=1')
    },
  },
  watch: {
    // useType (val) {
    // 	this.params = this.obj[val].params
    // }
    terminal(val) {
      console.log(val)
      this.term = val
    }
  }
}
</script>
<style lang="less">
@deep: ~">>>";

.carQuery {
  @{deep}.van-tab--active {
    font-size: @font-size-16;
  }

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  .left-back {
    width: 0.8rem;
    position: absolute;
    bottom: 0;
  }

  .pad {
    padding: 16px;
  }

  .query {
    padding: 20px 24px;
  }

  .plus-card-wrap {
    margin: 0 12px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 10px;
    background-color: @color-background-white;
    border-radius: 4px;

    .card {
      padding: 6px 16px 0px;
    }

    .btn {
      width: auto;
    }

    .dBtn {
      display: inline-block;
      width: 1.35rem;
      height: 0.48rem;
      line-height: 0.46rem;
      text-align: center;
      border-radius: 24px;
      border: 1px solid;
      font-size: @font-size-12;
    }

    .search-card {
      font-size: @font-size-16;

      >div {
        height: 1.1rem;
      }

      div.disable {
        color: @color-text-gray;
      }

      .cxr {
        font-family: @font-bold-md;
      }

      .city {
        font-size: @font-size-20;
        font-family: @font-bold-lg;

        .city-icon {
          flex-grow: 0;
          min-width: 0.58rem;
          height: 0.58rem;
        }

        .dest-city {
          text-align: right;
        }
      }

      .date {
        .dest-date {
          text-align: right;
          font-family: @font-bold-md;
        }

        .date-tip {
          font-size: @font-size-24;
        }

        .datepicker__wrapper {
          width: 0;
          height: 0;
          overflow: hidden;
        }
      }
    }
  }

  .flight-disabled {
    background: #f5f5f5;
    color: #00000040;
  }
}

iframe {
  width: 100%;
  height: calc(100vh - 50px);
  border: 0;
}

.mapBox {
  width: 100vw;
  height: calc(100vh - 300px);
  position: absolute;
  top: 0;
  overflow: hidden;
}

.airport-pickup-col .van-cell {
  /* 在这里放置你的样式调整 */
  padding: 10px 0px 10px 16px !important;
}
</style>
